var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.76163 6.99539L7.19935 1.55767C8.60958 0.147443 10.896 0.147443 12.3062 1.55767C13.7165 2.9679 13.7165 5.25433 12.3062 6.66455L6.86852 12.1023C5.99776 12.9337 4.61776 12.9218 3.76203 12.0661C2.89419 11.1982 2.89419 9.7912 3.76203 8.92337L9.16354 3.52186C9.48897 3.19642 10.0166 3.19642 10.342 3.52186C10.6675 3.84729 10.6675 4.37493 10.342 4.70037L4.94054 10.1019C4.72358 10.3188 4.72358 10.6706 4.94054 10.8876C5.15749 11.1045 5.50925 11.1045 5.72621 10.8876L11.1277 5.48604C11.8871 4.72669 11.8871 3.49553 11.1277 2.73618C10.3684 1.97683 9.13721 1.97683 8.37786 2.73618L2.97635 8.13769C1.6746 9.43944 1.6746 11.55 2.97635 12.8517C4.2781 14.1535 6.38865 14.1535 7.6904 12.8517L12.1098 8.43232C12.4353 8.10688 12.9629 8.10688 13.2883 8.43232C13.6138 8.75776 13.6138 9.28539 13.2883 9.61083L8.86891 14.0302C6.91629 15.9829 3.75046 15.9829 1.79784 14.0302C-0.142699 12.0897 -0.154707 8.95093 1.76182 6.99557L1.76163 6.99539Z",
    fill: "#92929D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPin);
export default __webpack_public_path__ + "static/media/Pin.37a26d6677f7596f5f5ddf33f4eb423a.svg";
export { ForwardRef as ReactComponent };